import UploadFileInput from 'Pages/Pipelines/CreateTask/Forms/Parameters/UploadFileInput';
import EditableInput from 'Components/Weaver/Input/EditableInput';
import Json5Vars from 'Pages/Pipelines/CreateTask/Forms/Parameters/Json5Vars'
import { Form } from 'antd';

export default function ParametersForm({ form, functionality, initialValues, ...props }) {
  const properties = functionality?.configDefinition?.properties || {};
  const relevantProperties = Object.entries(properties).filter(
    ([key, configProps]) => key === 'file' || configProps.subType === 'json5-with-vars'
  );

  return (
    <Form
      form={form}
      initialValues={initialValues}
    >
      {
        relevantProperties.map(([key, configProps]) => {
          if (key === 'file') {
            return (
              <Form.Item
                name={key}
                key={key}
              >
                <UploadFileInput
                  field={key}
                  form={form}
                  onFileSelect={() => undefined}
                  {...configProps}
                />
              </Form.Item>
            );
          } else if (configProps.subType === 'json5-with-vars' && !_.isEmpty(initialValues[key])) {
            return (
              <Json5Vars
                field={key}
                form={form}
                value={initialValues[key]}
                key={key}
                {...configProps}
              />
            );
          } else if (configProps.subType === 'json5-with-vars' && _.isEmpty(initialValues[key])) {
            return <></>;
          } else {
            return (
              <Form.Item
                name={key}
                key={key}
              >
                <EditableInput form={form} {...configProps} />
              </Form.Item>
            );
          }
        })
      }
    </Form>
  );
}